import API from '@/api/apiUrls'
import { useDjango } from '@/composables/useDjango'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const { api } = useDjango()

type AuthenticatePayload = {
  email: string
  password: string
}

// TODO transfer to typescript
export const useDjangoAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const isInitDone = ref(false)

  async function authenticate({ email, password }: AuthenticatePayload) {
    await api.apiService.authenticationHandler.authenticate(email, password)
    const userResponse = await api.service(API.CORE.USERS.CURRENT_USER).get()
    user.value = userResponse
    isInitDone.value = true
    return { user: userResponse }
  }

  async function reAuthenticate() {
    try {
      await api.apiService.authenticationHandler.setAccessTokenInHeaderFromStore()
      const userResponse = await api.service(API.CORE.USERS.CURRENT_USER).get()
      user.value = userResponse
      isInitDone.value = true
      return { user: userResponse }
    } catch {
      user.value = null
      isInitDone.value = true
      return { user: null }
    }
  }

  async function logout() {
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
    user.value = null
  }

  return {
    user,
    isInitDone,
    authenticate,
    reAuthenticate,
    logout
  }
})
